// This script handles the navigation slide toggle
jQuery(document).ready(function ($) {
	$(".menu-icon").click(function () {
		$(".desktop-menu").slideToggle();
		$(".title-bar").toggleClass('solid-bg');
	});
});
